import { useMemo } from "react";

export function TestimonialsSection({ testimonials }) {
  const testimonialCards = useMemo(() => testimonials.map((testimonial) => ({
    ...testimonial,
    context: [testimonial.condition, testimonial.zone].filter(Boolean).join(" · "),
  })), [testimonials]);
  if (testimonialCards.length === 0) return null;
  return (
    <div className="bg-white py-12 px-4" data-testid="testimonials-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="text-brand-red text-xs font-body font-bold uppercase tracking-widest mb-3">Community Voices</div>
          <h2 className="font-heading text-3xl sm:text-4xl text-navy font-bold">What Patients Are Saying</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonialCards.map((t) => (
            <div key={t.id} className="bg-slate-50 border border-gray-100 rounded-2xl p-6 relative" data-testid={`testimonial-${t.id}`}>
              <p className="font-body text-sm text-gray-700 leading-relaxed mb-4 italic">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-navy text-white flex items-center justify-center font-body text-sm font-bold">{t.authorName?.charAt(0)}</div>
                <div>
                  <div className="font-body text-sm font-bold text-navy">{t.authorName}</div>
                  <div className="font-body text-xs text-gray-500">{t.context}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
